import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 265;
const S = 32;
const A1 = 185;
const A2 = 48;
const L = hsl(H, 72, 82);
const GEM = hsl(A1, 88, 78);
const GOLD = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'cristais',
  name: 'Cristais',
  seed: 'cristais',
  legacy: false,
  hue: H,
  ceil: hsl(H, 0.8 * S, 28),
  font: 'Righteous',
  fontFile: 'righteous-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.36,
  fillAlpha: 0.74,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: GEM,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: { circle: L, square: GOLD, triangle: lerpColor(L, GEM, 0.5), hex: lerpColor(L, GOLD, 0.5) },
    spot: GOLD,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [GEM, GOLD, L, RIM],
  },
  burst: { count: 12, speed: 0.55, drag: 3.6, gravity: 0.2, spin: 5, life: 0.9, sizeMin: 0.01, sizeMax: 0.024 },
  dress,
  fx,
  paint,
};

export default world;
